import React from 'react';
import { Users, ShieldAlert } from 'lucide-react';
import { Button } from './ui/button';

const Services = ({ onConsultationClick }) => {
  return (
    <section id="services" className="py-20 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
            Our Services
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Specialised solutions for hospitality operators seeking operational stability.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Hospitality Recruitment */}
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:border-[#FFD000] transition-all duration-300 group flex flex-col">
            <div className="relative h-48 flex-shrink-0">
              <img 
                src="https://images.unsplash.com/photo-1694771169758-f7036fd5ad67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBib3V0aXF1ZSUyMGxvZGdlJTIwZXh0ZXJpb3IlMjBhZnJpY2F8ZW58MHx8fHwxNzc2MDE1MTYxfDA&ixlib=rb-4.1.0&q=85"
                alt="Luxury Boutique Lodge"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-4 left-4">
                <div className="bg-[#FFD000] p-2 rounded-lg">
                  <Users className="h-6 w-6 text-black" />
                </div>
              </div>
            </div>
            
            <div className="p-6 flex flex-col h-full">
              <h3 className="text-lg font-normal text-black mb-3">
                Hospitality Recruitment
              </h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                Leadership stability recruitment specialising in:
              </p>
              <ul className="space-y-2 mb-6 flex-grow">
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">General Managers</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">Floor Managers</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">Head Chefs</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">Senior FOH & BOH</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">Operational leadership roles</span>
                </li>
              </ul>
              <div className="mt-auto">
                <p className="text-gray-600 italic mb-4 text-sm">
                  Not volume staffing. Leadership stability recruitment.
                </p>
                <Button 
                  onClick={onConsultationClick}
                  className="w-full bg-[#FFD000] hover:bg-[#FFD000]/90 text-black font-semibold text-sm"
                >
                  Discuss a Role
                </Button>
              </div>
            </div>
          </div>

          {/* Operational Risk Audit */}
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:border-[#FFD000] transition-all duration-300 group flex flex-col">
            <div className="relative h-48 flex-shrink-0">
              <img 
                src="https://images.unsplash.com/photo-1773100699991-b7e6bf89a6a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxmaW5lJTIwZGluaW5nJTIwc2VydmljZXxlbnwwfHx8fDE3NzE0MzU0Mjd8MA&ixlib=rb-4.1.0&q=85"
                alt="Operational Risk Audit"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-4 left-4">
                <div className="bg-[#FFD000] p-2 rounded-lg">
                  <ShieldAlert className="h-6 w-6 text-black" />
                </div>
              </div>
            </div>
            
            <div className="p-6 flex flex-col h-full">
              <h3 className="text-lg font-normal text-black mb-3">
                Hospitality Operational Risk Audit
              </h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                Structured operational observation service for restaurants experiencing:
              </p>
              <ul className="space-y-2 mb-6 flex-grow">
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">High turnover patterns</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">Recurring behavioural issues</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">Service inconsistency</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#FFD000] mr-2 text-sm">•</span>
                  <span className="text-gray-700 text-sm">Management instability</span>
                </li>
              </ul>
              <div className="mt-auto">
                <p className="text-gray-600 italic mb-4 text-sm">
                  Preventative operational insight, not generic consulting.
                </p>
                <Button 
                  onClick={onConsultationClick}
                  className="w-full bg-[#FFD000] hover:bg-[#FFD000]/90 text-black font-semibold text-sm"
                >
                  Request an Audit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
